<template>
  <vue-apex-charts
    class="comlnchart"
    ref="voteChartLine"
    type="line"
    height="550"
    :options="chartOptionsLine"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
const shapeMap = ['circle', 'triangle', 'square', 'sparkle', 'diamond'];

export default {
  name: "VoteChartLine",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsLine: {
        chart: {
          height: 500,
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'middle',
          formatter: function (val) {
            return Math.round(val * 10) / 10 + "%"
          },
          offsetY: -5,
          background: {
            enabled: false
          },
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1.5,
          curve: 'smooth',
        },
        markers: {
          size: 4,
          hover: {
            size: 5
          }
        },
        xaxis: {
          categories: [],
          tooltip: {
              enabled: false,
          },
          crosshairs: {
            show: true,
            dropShadow: {
              enabled: true,
              top: 0,
              left: 0,
              blur: 0,
              opacity: 0.4,
            },
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
              formatter(value) {
                return Math.round(value * 100) / 100;
              },
            },
            tooltip: {
              enabled: false,
            },
          },
        ],
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "center",
          itemMargin: {
            horizontal: 5,
            vertical: 2,
          },
          onItemClick: {
            toggleDataSeries: true
          },
          onItemHover: {
            highlightDataSeries: true
          },
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#404040',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
      },

      series: [],
    };
  },
  props: {
    voteChartLine: {
      type: Array,
      default: () => [],
    },
    lineChartCategories: {
      type: Array,
      default: () => [],
    },
    lineChartDesc: {
      type: Array,
      default: () => [],
    },
    isChartInit: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    voteChartLine(newVal) {      
      if (!this.isChartInit) {
        const voteChartLineOption = {
          noData: {
            text: '분석중...',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
              color: '#404040',
              fontSize: '20px',
              fontFamily: "NanumBarunGothicB"
            }
          },
        };
        this.series = [];
        this.$refs.voteChartLine.updateOptions(voteChartLineOption, true);
        return;
      }

      if(this.lineChartDesc.length > 0){
        this.setValues(newVal, this.lineChartCategories, this.lineChartDesc)
      }
    },
  },
  methods: {
    setValues(newVal, newCategories, newDesc){
      var colors = [];
      var shapes = [];
      
      for (let i = 0; i < newVal.length; i++) {
        shapes.push(shapeMap[Math.floor(i / colorMap.length) % shapeMap.length]);
        colors.push(colorMap[i % colorMap.length]);
      }

      const voteChartLineOption = {
        xaxis: {
          categories: newCategories,
        },
        tooltip: {
          followCursor: true,
          enabled: true,
          fixed: {
            enabled: false,
          },
          custom: function({series, seriesIndex, dataPointIndex, w}, description=newDesc) {    
            var freq = parseFloat(description[seriesIndex][dataPointIndex]).toLocaleString()        

            var hexColor = w.globals.colors[seriesIndex].replace('#', '')
            const r = parseInt(hexColor.substring(0, 2), 16)
            const g = parseInt(hexColor.substring(2, 4), 16)
            const b = parseInt(hexColor.substring(4, 6), 16)
            hexColor = `rgb(${r}, ${g}, ${b})`

            return '<div>' +
                '<div class="apexcharts-tooltip-title" style="font-family: NanumBarunGothic; font-size: 12px;">' + w.globals.categoryLabels[dataPointIndex] + '</div>' +
                '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">' +
                '<span class="apexcharts-tooltip-marker" style="background-color: ' + hexColor + ';"></span>' + 
                '<div class="apexcharts-tooltip-text" style="font-family: NanumBarunGothic; font-size: 12px;">' +
                '<div class="apexcharts-tooltip-y-group">' +
                '<span class="apexcharts-tooltip-text-label">' + w.globals.seriesNames[seriesIndex] + ' : ' + '</span>' +
                '<span class="apexcharts-tooltip-text-value">' + freq + '</span>' +
                '</div>' +
                '<div class="apexcharts-tooltip-z-group">' +
                '<span class="apexcharts-tooltip-text-z-label"></span>' +
                '<span class="apexcharts-tooltip-text-z-value"></span>' +
                '</div></div></div></div>';
          }
        },
        colors: colors,
        markers: {
          shape: shapes,
        },
        legend: {
          markers: {
            shape: shapes,
          }
        },
      };

      this.series = newVal;
      this.$refs.voteChartLine.updateOptions(voteChartLineOption, true);
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.comlnchart .apexcharts-canvas .apexcharts-legend-series .apexcharts-legend-text {
  color: #6e6b7b !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  padding-left: 0px;
}

.comlnchart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
  color: #333;
  background: #fff;
}

.comlnchart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
  color: #333;
  background: #fff;
}

.comlnchart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}

.comlnchart .apexcharts-canvas .apexcharts-text {
  font-family: NanumBarunGothicB !important;
}

</style>
  